import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthNavigationService } from 'src/app/services/auth-navigation.service';
import { LoginService } from 'src/app/services/login.service';
import { MfaService } from 'src/app/services/mfa.service';

/**
 * MfaVerifyComponent is the standalone second-factor page. After a password
 * login that returned `mfa_required`, the user enters a TOTP or backup code
 * here; on success a full session is issued and we route by role.
 */
@Component({
  selector: 'app-mfa-verify',
  templateUrl: './mfa-verify.component.html',
  styleUrl: './mfa-verify.component.scss',
})
export class MfaVerifyComponent implements OnInit {
  submitting: boolean = false;
  error: string = '';

  codeForm: UntypedFormGroup = new UntypedFormGroup({
    code: new UntypedFormControl('', Validators.required),
  });

  constructor(
    private _mfaService: MfaService,
    private _loginService: LoginService,
    private _authNavigationService: AuthNavigationService,
    private _router: Router
  ) {}

  ngOnInit(): void {
    // No pre-auth token (direct navigation or reload) -> back to login.
    if (!this._mfaService.preAuthToken) {
      this._router.navigate(['/login']);
    }
  }

  verify() {
    if (!this.codeForm.valid) {
      return;
    }
    this.submitting = true;
    this.error = '';
    const code = this.codeForm.get('code')?.value;
    this._mfaService.mfaVerify(code).subscribe({
      next: (response) => {
        this.submitting = false;
        if (response.success && response.token) {
          this._mfaService.preAuthToken = '';
          this._loginService.applyLoginResponse(response);
          this._authNavigationService.navigateAfterLogin();
        } else {
          this.error = 'mfa.codeError';
        }
      },
      error: () => {
        this.submitting = false;
        this.error = 'mfa.codeError';
      },
    });
  }

  backToLogin() {
    this._mfaService.preAuthToken = '';
    this._router.navigate(['/login']);
  }
}
